"use client";

import { useEffect, useRef, useState } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { webEnv } from "@/environment/environment";
import { useGqlClient } from "@/Providers/GQLProvider";
import { useMutation } from "@tanstack/react-query";
import { CreateUserLogInput } from "@/__generated__/graphql";
const useTrackPath = () => {
  const gqlClient = useGqlClient();
  const { mutate } = useMutation({
    mutationFn: (data: CreateUserLogInput) => {
      return gqlClient.createUserLog({
        createUserLogInput: { ...data },
      });
    },
  });
  const refererRef = useRef<string | null>(null);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const params = searchParams.toString();
  const path = pathname + (params ? "?" : "") + params;
  useEffect(() => {
    const data = {
      currentPath: path,
      referer: refererRef.current || document.referrer || null,
      //   timestamp: new Date().toISOString(),
    };
    mutate(data);
    // console.log("Current Path:", data);
    refererRef.current = new URL(path, webEnv.siteUrl).toString();
  }, [path]);
};

export default useTrackPath;
